import LegalPageLayout from "@/components/legal/LegalPageLayout";
import { politiqueConfidentialiteContent } from "@/data/legal/politiqueConfidentialiteContent";

export default function PolitiqueConfidentialitePage() {
  return <LegalPageLayout content={politiqueConfidentialiteContent} testId="politique-confidentialite-page" />;
}
